<template>
  <section>
    <div>
      <div class="columns is-multiline is-gapless">
        <div
          v-for="(item, index) in images"
          :key="index"
          class="column is-4 is-12-mobile"
        >
          <b-carousel
            :indicator="false"
            :pause-info="false"
          >
            <b-carousel-item>
              <section :class="`hero ${item.bg} is-bold`">
                <div class="text-centered minHeighSeparator">
                  <div>
                    <h2 class="has-text-white is-size-3 fontWeightBlack fontUpperCase paddingSeparatorImages mt-7">
                      {{ item.title }}
                    </h2>
                    <h2 :class="`has-text-white is-size-4 fontWeightRegular letterSpacingShort | p-5`">
                      {{ item.subtitle }}
                    </h2>
                  </div>
                </div>
              </section>
            </b-carousel-item>
          </b-carousel>
            <div class="columns bgColorPrimary is-hidden-tablet">
              <div class="column is-12">
                  <p
                    class="mx-auto p-3 | has-text-centered letterSpacingShort fontWeight is-size-6 fontItalic heartbeat"
                    v-if="index === 0"
                  >
                    Las reparaciones más confiables
                  </p>
                  <p
                    class="mx-auto p-3 | has-text-centered letterSpacingShort fontWeight is-size-6 fontItalic heartbeat"
                    v-if="index === 1"
                  >
                    Vamos en el momento ¡Llamá ahora!
                  </p>
                  <p
                    class="mx-auto p-3 | has-text-centered letterSpacingShort fontWeight is-size-6 fontItalic heartbeat"
                    v-if="index === 2"
                  >
                    Elegí LF Soluciones
                  </p>
              </div>
            </div>
          </div>
        </div>
      </div>
  </section>
</template>

<script>
export default {
  name: 'Slider',
  data () {
    return {
        progress: true,
        progressType: 'is-primary',
        images: [
            {
            title: 'Instalaciones completas',
            subtitle: 'Intalaciones completas de plomería y gas en obras de viviendas y edificios',
            bg: 'bgFistSection2'
            },
            {
            title: 'Reparaciones generales',
            subtitle: 'Reparamos calefones, termotanques, cocinas, estufas y más',
            bg: 'bgFistSection1'
            },
            {
            title: 'Bombas presurizadoras',
            subtitle: 'Tené siempre el tanque lleno de agua con las bombas presurizadas',
            bg: 'bgFistSection3'
            }
        ]
    }
  }
}
</script>

<style lang="sass">

.bgFistSection1
    width: 100%
    min-height:400px
    background-size: cover
    background-image: url("../../assets/img/separatorImg1.jpg")

.bgFistSection2
    width:100%
    min-height:400px
    background-size: cover
    background-image: url("../../assets/img/separatorImg2.jpg")

.bgFistSection3
    width:100%
    min-height:400px
    background-size: cover
    background-image: url("../../assets/img/separatorImg3.jpg")

</style>
